/**
 * NOYKA Locale Engine — Constants
 *
 * Single source of truth for locale keys, supported languages, and region defaults.
 */

export const LOCALE_QUERY_PARAM = 'lang';
export const LOCALE_STORAGE_KEY = 'noyka_lang';
export const LOCALE_COOKIE_KEY = 'noyka_lang';
export const DEFAULT_LOCALE = 'en';

export const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur'] as const;

export const SUPPORTED_LOCALES = [
  'tr', 'en', 'ar', 'de', 'fr', 'es', 'it', 'pt', 'ru', 'zh',
  'ja', 'ko', 'nl', 'pl', 'sv', 'da', 'fi', 'no', 'cs', 'hu',
  'ro', 'bg', 'hr', 'sk', 'sl', 'el', 'uk', 'he', 'fa', 'hi',
  'ur', 'id', 'ms', 'th', 'vi', 'sr', 'az', 'ka', 'kk', 'ta', 'bn',
] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

/**
 * Region-to-locale fallback map.
 * Maps navigator country/language codes to a default locale.
 */
export const REGION_LOCALE_MAP: Record<string, SupportedLocale> = {
  tr: 'tr', az: 'tr', kk: 'tr',
  de: 'de', at: 'de', ch: 'de',
  fr: 'fr', be: 'fr',
  es: 'es', mx: 'es', ar: 'es', co: 'es', cl: 'es', pe: 'es',
  ru: 'ru', ua: 'ru',
  sa: 'ar', ae: 'ar', eg: 'ar', iq: 'ar',
  ir: 'fa',
  pk: 'ur',
  cn: 'zh', tw: 'zh', hk: 'zh',
  jp: 'ja',
  kr: 'ko',
  in: 'hi',
  br: 'pt', pt: 'pt',
  it: 'it',
  nl: 'nl',
  pl: 'pl',
  se: 'sv',
  dk: 'da',
  fi: 'fi',
  no: 'no',
  cz: 'cs',
  hu: 'hu',
  ro: 'ro',
  bg: 'bg',
  hr: 'hr',
  sk: 'sk',
  si: 'sl',
  gr: 'el',
  ge: 'ka',
  id: 'id',
  my: 'ms',
  th: 'th',
  vn: 'vi',
  rs: 'sr',
  il: 'he',
  bd: 'bn',
  lk: 'ta',
};
